export default __webpack_public_path__ + "static/verticals-mobile-8310aef05fe718c9d9abac8d7a0ff233.png";